import React from 'react';
import { IoImageOutline } from 'react-icons/io5';

const BookPlaceholder = () => {
  return (
    <div className='w-full h-[240px] bg-card rounded-lg flex items-center justify-center'>
      <IoImageOutline className='text-3xl text-white/40' />
    </div>
  );
};

export default BookPlaceholder;
